export const FETCH_CUSTOMERS_HELPED_REQUEST =
  'reports/customersHelped/FETCH_CUSTOMERS_HELPED_REQUEST'
export const FETCH_CUSTOMERS_HELPED_RESPONSE =
  'reports/customersHelped/FETCH_CUSTOMERS_HELPED_RESPONSE'
export const FETCH_CUSTOMERS_HELPED_ERROR =
  'reports/customersHelped/FETCH_CUSTOMERS_HELPED_ERROR'
